export default {
  name: {
    id: 'rm_metal_barium_name',
    defaultMessage: 'Barium',
  },
  smartphoneLabel: {
    id: 'rm_metal_barium_smartphone_label',
    defaultMessage: 'Low (about a grain of rice)',
  },
  whatItDoesText: {
    id: 'rm_metal_barium_what_it_does',
    defaultMessage:
      'Barium compounds, such as barium titanate (BaTiO₃), are used in smartphone electronics. Barium titanate is a dielectric ceramic widely used in multilayer ceramic capacitors (MLCCs). These components store and release electrical charge, helping to stabilise voltage and keep circuits functioning reliably.',
  },
  extractionText1: {
    id: 'rm_metal_barium_extraction_p1',
    defaultMessage:
      'Barite (BaSO₄), one of barium’s main ores, is mined by open-pit or underground methods. The ore is crushed, washed and deslimed, then concentrated mainly by gravity separation, with flotation used for finer ores. This produces a concentrate containing around 80% to 95% BaSO₄. To make barium compounds, barite can be reduced with carbon to barium sulfide, then converted into barium carbonate. Barium metal requires further reduction of a purified barium compound.',
  },
  quickFactText: {
    id: 'rm_metal_barium_quick_fact',
    defaultMessage:
      'Barium is not mined as a metal: it starts as barite, a dense mineral used in drilling fluids, glass, ceramics and electronics. It is widely available, but barely recycled.',
  },
  envSummaryText: {
    id: 'rm_metal_barium_env_summary',
    defaultMessage:
      'Barite mining can disturb land and generate dust, waste rock and fine tailings. Barite itself is stable and poorly soluble, but associated trace metals in some deposits can contaminate water and soil if mining waste is not properly contained.',
  },
  envWaterText: {
    id: 'rm_metal_barium_env_water_text',
    defaultMessage:
      'Mining and processing can generate fine tailings and wastewater. Seepage from tailings storage, storm events or dam failures can contaminate groundwater and surface water with associated metals such as lead, zinc, arsenic, cadmium and mercury.',
  },
  envSoilText: {
    id: 'rm_metal_barium_env_soil_text',
    defaultMessage:
      'Open-pit extraction removes soil and rock, while waste rock and fine residues can accumulate near mining operations. In sulfide-bearing deposits, associated metals can leach from tailings into surrounding soils.',
  },
  envBiodiversityText: {
    id: 'rm_metal_barium_env_biodiversity_text',
    defaultMessage:
      'Open pits, access roads, processing facilities, waste rock and tailings can transform landscapes and disturb habitats. No global, barite-specific biodiversity assessment or quantified impact was identified.',
  },
  humanSummaryText: {
    id: 'rm_metal_barium_human_summary',
    defaultMessage:
      'Artisanal and small-scale barite mining is often informal. In some regions, more than half of miners report health problems or use little or no protective equipment. Local communities may also depend on contaminated water sources near mining sites.',
  },
  humanHealthText: {
    id: 'rm_metal_barium_human_health_text',
    defaultMessage:
      'Barite (BaSO₄) is considered non-toxic under normal conditions because it is highly insoluble and is not absorbed by the body. However, prolonged inhalation of fine dust generated during mining and processing can cause respiratory irritation.',
  },
  humanLegalText: {
    id: 'rm_metal_barium_human_legal_text',
    defaultMessage:
      'In some regions, around 50% to 75% of artisanal and small-scale barite miners operate without formal licences. This can weaken the enforcement of safety and labour standards and limit access to healthcare and compensation.',
  },
  geoSummaryText: {
    id: 'rm_metal_barium_geo_summary',
    defaultMessage:
      'Barite is a widely distributed bulk mineral, but barium supply still depends on the availability and processing of barite. The European Union is around 75% reliant on imports for its barite consumption. China and Morocco together provide more than 70% of EU barite supply, creating exposure to trade and logistics disruptions.',
  },
  geoDugText: {
    id: 'rm_metal_barium_geo_dug_text',
    defaultMessage:
      'More than half of global barite mine production is concentrated in India, China and Morocco. India is the largest producer, accounting for approximately 24% of global production in 2024. These figures refer to barite (BaSO₄), the main barium-bearing mineral, not to barium metal.',
  },
  geoProcessedText: {
    id: 'rm_metal_barium_geo_processed_text',
    defaultMessage:
      'After mining, barite is crushed, washed, deslimed and concentrated, mainly by gravity separation. It can then be converted into barium compounds used in glass, ceramics and electronics. For electronics-grade barium titanate used in capacitors, major manufacturers are based in Asian countries, including Japan, China and Taiwan.',
  },
  geoLeverageText: {
    id: 'rm_metal_barium_geo_leverage_text',
    defaultMessage:
      'No major barium-metal export restriction is documented in these sources. However, China and Morocco, the EU’s main barite suppliers, have imposed export taxes below 25%. Because the EU relies heavily on imports, trade measures or logistical disruptions affecting these suppliers could affect the availability of barite and downstream barium compounds.',
  },
  supplySummaryText: {
    id: 'rm_metal_barium_supply_summary',
    defaultMessage:
      'Global barite supply is projected to expand steadily, driven mainly by oil and gas drilling. However, the European Union remains around 75% dependent on imports, while geographic concentration, logistics costs and possible reduced exports from India’s Mangampet deposit create supply risks. These figures concern barite, not barium metal.',
  },
  supplyReservesText: {
    id: 'rm_metal_barium_supply_reserves_text',
    defaultMessage:
      'The USGS report does not provide a complete global reserve total in its 2025 barite table. It estimates global barite resources at about 2 billion tonnes, of which approximately 740 million tonnes are identified resources. Reported reserves include China (110 million tonnes), Iran (100 million), Kazakhstan (85 million), India (51 million), Turkey (34 million) and Russia (12 million). Resources are broader than economically recoverable reserves, so these figures do not provide a fixed depletion date.',
  },
  supplyDemandText: {
    id: 'rm_metal_barium_supply_demand_text',
    defaultMessage:
      'Global barite demand is driven mainly by oil and gas drilling, which accounts for around 69% of consumption. In the EU, about 70% is used as a filler in paints, plastics, rubber and paper, 20% in drilling fluids, and 5% each in chemical applications and radiation shielding. These figures describe barite consumption, not demand for barium metal or from the consumer-electronics industry.',
  },
  recyclingSummaryText: {
    id: 'rm_metal_barium_recycling_summary',
    defaultMessage:
      'Barite recycling is extremely limited, with an estimated end-of-life recycling input rate of around 1%. Its main uses are dissipative or embedded in products, making recovery technically and economically difficult.',
  },
  recyclingInputText: {
    id: 'rm_metal_barium_recycling_input_text',
    defaultMessage:
      'The available estimate concerns barite recycling, not barium metal. Around 1% of material entering production is estimated to come from end-of-life sources. No separate recycling data have been reported for barium metal or barium recovered from consumer electronics.',
  },
  recyclingOutlookText: {
    id: 'rm_metal_barium_recycling_outlook_text',
    defaultMessage:
      'Not currently. Barite is dispersed through drilling fluids, paints, plastics, rubber and other products, so most end-of-life material is not recovered. Some mining tailings can be reprocessed to produce high-purity BaSO₄ concentrates, but this remains a limited secondary source rather than a mature closed-loop recycling system. No recycling data have been reported for barium metal or barium recovered from consumer electronics.',
  },
  footnote1Text1: {
    id: 'rm_metal_barium_footnote_1_p1',
    defaultMessage:
      'As barium is not covered by the ADEME 2024 study, its environmental, social, geopolitical and supply-risk scores were calculated by Back Market’s Sustainability team using ADEME’s methodology, public sources and AI assistance. These scores carry greater uncertainty. See the Sources tab for the full methodology and references.',
  },
  footnote2Text1: {
    id: 'rm_metal_barium_footnote_2_p1',
    defaultMessage:
      'The USGS data refer to barite mine production, not barium-metal production. Barite, also called baryte or barytes, is barium sulfate (BaSO₄), the main barium-bearing mineral. Barium metal and barium compounds are produced later from processed barite.',
  },
  footnote2Text2: {
    id: 'rm_metal_barium_footnote_2_p2',
    defaultMessage:
      'The United States’ production is withheld in the USGS 2025 report, so its individual share cannot be reported directly.',
  },
} as const
